// Libraries
import { QueryFunctionContext } from '@tanstack/react-query';
// Services
import { getPerformanceVoyage } from '@services/index';
// Schemas
import { PerformanceVoyageSchema } from '@services/apiGateway';
// Types
import { VesselVoyageControllerParams } from '@globalTypes/index';

/**
 * Fetches performance data for a specific voyage of a vessel belonging to a client.
 *
 * @async
 * @function performanceVoyageController
 * @typedef { imo: number, voyageId: string } QueryFunctionContextParams
 * @typedef {[_: any, params: QueryFunctionContextParams]} QueryFunctionContext
 * @param {QueryFunctionContext} queryKey - The context object containing the query key.
 * @param {Array} queryKey
 * @param {number} params.imo - The IMO number of the vessel.
 * @param {string} params.voyageId - The ID of the voyage.
 * @returns {Promise<PerformanceVoyage>} - A promise that resolves to the fetched performance voyage data.
 */
export const performanceVoyageController = async ({ queryKey }: QueryFunctionContext) => {
  const [_, params] = queryKey;

  const { imo, voyageId } = params as VesselVoyageControllerParams;

  const { data } = await getPerformanceVoyage(imo, voyageId);

  return PerformanceVoyageSchema.parse(data);
};
